import inherits from 'inherits';

import ContextPadProvider from 'bpmn-js/lib/features/context-pad/ContextPadProvider';

import {assign, bind} from 'min-dash';


export default function CustomContextPadProvider(injector, connect, translate) {

  injector.invoke(ContextPadProvider, this);

  let cached = bind(this.getContextPadEntries, this);

  this.getContextPadEntries = function (element) {
    let actions = cached(element);

    assign(actions, {
      'setting': {
        group: 'edit',
        className: 'bpmn-icon-service',
        title: translate('Element Settings'),
        action: {
          click: function elementSettings(event, element) {
            document.dispatchEvent(new CustomEvent('element.setting', { bubbles: true, detail: { element: element } }))
          }
        }
      }
    });

    return actions;
  };
}

inherits(CustomContextPadProvider, ContextPadProvider);

CustomContextPadProvider.$inject = [
  'injector',
  'connect',
  'translate'
];
